<div class="flex flex-col p-6">
    <div class="mb-6">
        <h3 class="text-xl font-semibold text-gray-800">
            Create Support Ticket
        </h3>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-4">
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Select User <span class="text-red-500">*</span></label>
            <select formControlName="user_id" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 bg-white outline-none">
                <option [ngValue]="null" disabled>Select a user...</option>
                <option *ngFor="let user of users" [value]="user.id">{{ user.name }} ({{ user.email }})</option>
            </select>
        </div>
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Subject <span class="text-red-500">*</span></label>
            <input type="text" formControlName="subject" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none" />
        </div>
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Description <span class="text-red-500">*</span></label>
            <textarea rows="4" formControlName="description" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 outline-none resize-none"></textarea>
        </div>
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Priority <span class="text-red-500">*</span></label>
            <select formControlName="priority" class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-blue-500 bg-white outline-none">
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
            </select>
        </div>

        <div class="flex justify-end gap-3 pt-6 border-t mt-6">
            <button type="button" (click)="cancel.emit()" class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">Cancel</button>
            <button type="submit" [disabled]="form.invalid" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg disabled:opacity-50 hover:bg-blue-700 transition">Create</button>
        </div>
    </form>
</div>
